/**
 * Card Component
 * Encapsulated Card with consistent styling
 */

import React from 'react';
import { Card as MuiCard, CardProps as MuiCardProps } from '@mui/material';

export interface CardProps extends MuiCardProps {
  // Inherits all MuiCard props
}

export const Card: React.FC<CardProps> = ({ 
  sx,
  children,
  ...props 
}) => {
  return (
    <MuiCard
      sx={{
        ...sx,
      }}
      {...props}
    >
      {children}
    </MuiCard>
  );
};

